const marketingHosts = new Set(["haulbase.ai", "www.haulbase.ai", "localhost", "127.0.0.1"]);
const marketingPaths = new Set([
  "/",
  "/headless-haulbase",
  "/haulbase-agent",
  "/haulbase-atms",
  "/blog",
  "/learn",
  "/use-cases",
  "/compare",
  "/book-demo",
  "/playbook",
  "/apply",
  "/email-preferences",
  "/purchase/access",
  "/purchase/complete",
]);

// Content hubs and legal pages are served as path trees on the marketing host.
const marketingPathPrefixes = ["/playbook/", "/learn/", "/use-cases/", "/compare/", "/legal/"];

// SEO machine endpoints that must resolve publicly on the marketing host.
const marketingFilePaths = new Set(["/sitemap.xml", "/robots.txt", "/llms.txt", "/llms-full.txt", "/feed.xml"]);

export function normalizeHost(hostHeader: string | null): string {
  return hostHeader?.split(":")[0]?.toLowerCase() ?? "";
}

export function isMarketingHost(hostHeader: string | null): boolean {
  const host = normalizeHost(hostHeader);
  return !host || marketingHosts.has(host);
}

export function isMarketingPath(pathname: string): boolean {
  const normalized = pathname.endsWith("/") && pathname !== "/" ? pathname.slice(0, -1) : pathname;
  if (marketingPaths.has(normalized) || marketingFilePaths.has(normalized)) {
    return true;
  }
  return marketingPathPrefixes.some((prefix) => pathname.startsWith(prefix));
}
